export const LS_PUSH_SUBSCRIPTIONS = 'flashChat_pushSubscriptions';
export const SUBSCRIPTION_ID = 'flashChat_subscriptionId';
